import { DestinationUrlValue } from '../elements/Fields'
import { projectOwnApprovedDestinations } from '../elements/OwnApprovedDestinationUrlsEditor'
import { filterDestinationUrlsByCatalog } from './filterDestinationUrlsByCatalog'
import { getDestinationName } from './getDestinationName'

export type FormattedDestinationUrl = {
  publisher_id?: string
  name?: string
  code?: string
  url?: string
}

// The read-only list the panel shows. A sub-publisher that already decided
// sees its own projected links; everyone else sees the single URL or the
// brand list sorted by name.
export const formatDestinationUrls = ({
  isSubpublisherReview,
  pendingReviewMode,
  savedDestinationUrls,
  destinationsConfig,
  catalogLoaded = false,
  isSingleDestination,
  destinationUrl,
  destinationUrls
}: {
  isSubpublisherReview: boolean
  pendingReviewMode: boolean
  savedDestinationUrls?: Parameters<typeof projectOwnApprovedDestinations>[0]
  destinationsConfig?: DestinationUrlsConfig[]
  catalogLoaded?: boolean
  isSingleDestination: boolean
  destinationUrl?: string | null
  destinationUrls?: DestinationUrlValue[] | null
}): FormattedDestinationUrl[] | undefined => {
  if (isSubpublisherReview && !pendingReviewMode) {
    return projectOwnApprovedDestinations(
      savedDestinationUrls || [],
      destinationsConfig
    ).map(item => ({
      publisher_id: item.publisher_id,
      name: item.name,
      code: item.brand,
      url: item.url
    }))
  }

  if (isSingleDestination) return [{ url: destinationUrl }]

  if (!destinationUrls) return undefined

  return filterDestinationUrlsByCatalog(
    destinationUrls,
    destinationsConfig,
    catalogLoaded
  )
    .map(({ publisher_id, brand, url }) => ({
      publisher_id,
      name: getDestinationName(destinationsConfig, publisher_id, brand),
      code: brand,
      url
    }))
    .sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''))
}
